<p>svg-icon works!</p>
